export default function (bool) {
  if (bool) {
    document.getElementsByTagName('html')[0].className = "fixDiv"
  } else {
    document.getElementsByTagName('html')[0].className = ""
  }
}


// WEBPACK FOOTER //
// src/tools/forbidScroll.js